/* ==========================================================================
   Wire Gauge and Voltage Drop Calculator
   Self-contained. Loaded only on this calculator's page.
   No shared dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-pc-wgc]');
  if (!root) return;

  /* AWG copper resistance in ohms per 1,000 ft at 20C, standard table values.
     Aluminium wire runs roughly 60% higher and is not covered here. */
  var AWG = [
    { g: '4/0', r: 0.0490 }, { g: '3/0', r: 0.0618 }, { g: '2/0', r: 0.0779 },
    { g: '1/0', r: 0.0983 }, { g: '1',  r: 0.1239 },  { g: '2',  r: 0.1563 },
    { g: '4',   r: 0.2485 }, { g: '6',  r: 0.3951 },  { g: '8',  r: 0.6282 },
    { g: '10',  r: 0.9989 }, { g: '12', r: 1.588 },   { g: '14', r: 2.525 },
    { g: '16',  r: 4.016 },  { g: '18', r: 6.385 },   { g: '20', r: 10.15 },
    { g: '22',  r: 16.14 }
  ];

  /* Chassis-grounded circuits still have a return path, but through a large
     conductor. Treating it as 1.15x the one-way run is the usual allowance. */
  var CHASSIS_FACTOR = 1.15;
  var WIRE_FACTOR = 2.0;

  /* ====================================================================
     compute(input) -> result

     PURE. No DOM, no network, no globals. All calculator logic lives here
     so it can be reasoned about and tested in isolation.
     ==================================================================== */
  function dropFor(entry, lengthFt, amps, factor) {
    return lengthFt * factor * amps * (entry.r / 1000);
  }

  function compute(input) {
    if (!isFinite(input.volts) || input.volts <= 0) {
      return { ok: false, errors: ['Enter the system voltage.'] };
    }
    if (!isFinite(input.amps) || input.amps <= 0) {
      return { ok: false, errors: ['Enter how many amps the circuit draws.'] };
    }
    if (!isFinite(input.length) || input.length <= 0) {
      return { ok: false, errors: ['Enter the one way run length in feet.'] };
    }

    var factor = input.ground === 'wire' ? WIRE_FACTOR : CHASSIS_FACTOR;
    var targetPct = parseFloat(input.target) || 3;
    var maxDrop = input.volts * (targetPct / 100);

    /* Walk from smallest conductor upward and take the first that passes. */
    var pick = null;
    for (var i = AWG.length - 1; i >= 0; i--) {
      if (dropFor(AWG[i], input.length, input.amps, factor) <= maxDrop) { pick = AWG[i]; break; }
    }

    var status, figures;
    if (!pick) {
      status = { key: 'now', label: 'Larger than 4/0',
                 note: 'No standard automotive gauge meets that target over this distance. Shorten the run, move the power source closer, or split the load across two circuits.' };
      figures = [{ label: 'Recommended gauge', value: 'Over 4/0', muted: true,
                   sub: 'Out of practical range.' }];
    } else {
      var drop = dropFor(pick, input.length, input.amps, factor);
      var pct = (drop / input.volts) * 100;
      status = { key: 'good', label: pick.g + ' AWG',
                 note: 'Loses ' + num(drop, 2) + 'V over the run, which is ' + num(pct, 2) + '% of ' + num(input.volts, 1) + 'V.' };
      figures = [
        { label: 'Recommended gauge', value: pick.g + ' AWG',
          sub: 'Smallest copper conductor that stays inside your ' + num(targetPct, 0) + '% target.' },
        { label: 'Voltage at the load', value: num(input.volts - drop, 2) + ' V',
          sub: 'Down ' + num(drop, 2) + 'V from ' + num(input.volts, 1) + 'V at the source.' }
      ];
    }

    var rows = [{ head: 'Drop by gauge over ' + num(input.length, 0) + ' ft' }];
    AWG.forEach(function (e) {
      var d = dropFor(e, input.length, input.amps, factor);
      var p = (d / input.volts) * 100;
      if (p > 25) return;
      rows.push({ label: e.g + ' AWG', value: num(d, 2) + ' V  (' + num(p, 1) + '%)' });
    });

    var warnings = [];
    if (input.amps > 150) {
      warnings.push('Above 150A you are into battery cable territory. Fuse it at the source, within 18 inches of the battery.');
    }

    return { ok: true, errors: [], warnings: warnings, status: status,
             figures: figures, rows: rows };
  }

  /* ====================================================================
     Formatting
     ==================================================================== */
  function comma(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function num(n, dp) {
    if (!isFinite(n)) return '-';
    var v = Number(n).toFixed(dp == null ? 2 : dp);
    if (dp !== 0 && v.indexOf('.') > -1) v = v.replace(/\.?0+$/, '');
    var parts = v.split('.');
    return comma(parts[0]) + (parts[1] ? '.' + parts[1] : '');
  }

  function signed(n, dp) {
    if (!isFinite(n)) return '-';
    return (n > 0 ? '+' : '') + num(n, dp);
  }

  /* ====================================================================
     DOM wiring
     ==================================================================== */
  var FIELDS = [
      {
          "name": "volts",
          "key": "v",
          "type": "number"
      },
      {
          "name": "amps",
          "key": "a",
          "type": "number"
      },
      {
          "name": "length",
          "key": "l",
          "type": "number"
      },
      {
          "name": "target",
          "key": "t",
          "type": "select"
      },
      {
          "name": "ground",
          "key": "g",
          "type": "select"
      }
  ];

  var els = {
    error:    root.querySelector('[data-r-error]'),
    status:   root.querySelector('[data-r-status]'),
    statusLbl:root.querySelector('[data-r-status-label]'),
    statusVal:root.querySelector('[data-r-status-value]'),
    statusNote:root.querySelector('[data-r-status-note]'),
    figures:  root.querySelector('[data-r-figures]'),
    rows:     root.querySelector('[data-r-rows]'),
    warnings: root.querySelector('[data-r-warnings]')
  };

  var STATUS_CLASSES = ['is-good','is-monitor','is-soon','is-now','is-critical'];

  function field(name) { return root.querySelector('[data-f="' + name + '"]'); }

  function readInput() {
    var o = {};
    FIELDS.forEach(function (f) {
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') o[f.name] = el.checked;
      else if (f.type === 'number') o[f.name] = parseFloat(el.value);
      else o[f.name] = el.value;
    });
    return o;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function renderFigures(figs) {
    els.figures.innerHTML = (figs || []).map(function (f) {
      return '<div class="pc-wgc__figure">'
        + '<div class="pc-wgc__figure-label">' + esc(f.label) + '</div>'
        + '<div class="pc-wgc__figure-value' + (f.muted ? ' is-muted' : '') + '">'
        + esc(f.value) + '</div>'
        + (f.sub ? '<div class="pc-wgc__figure-sub">' + esc(f.sub) + '</div>' : '')
        + '</div>';
    }).join('');
  }

  function renderRows(rows) {
    if (!els.rows) return;
    els.rows.innerHTML = (rows || []).map(function (r) {
      if (r.head) {
        return '<div class="pc-wgc__row pc-wgc__rows-head">' + esc(r.head) + '</div>';
      }
      return '<div class="pc-wgc__row">'
        + '<span class="pc-wgc__row-label">' + esc(r.label) + '</span>'
        + '<span class="pc-wgc__row-value">' + esc(r.value) + '</span>'
        + '</div>';
    }).join('');
  }

  function clearResult(message) {
    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      els.statusVal.textContent  = 'Waiting for your numbers';
      els.statusNote.textContent = message || '';
    }
    els.figures.innerHTML = '';
    if (els.rows) els.rows.innerHTML = '';
    if (els.warnings) els.warnings.style.display = 'none';
  }

  function render() {
    var input  = readInput();
    var result = compute(input);

    if (!result.ok) {
      els.error.textContent = result.errors[0];
      els.error.classList.add('is-shown');
      clearResult(result.errors[0]);
      return;
    }
    els.error.classList.remove('is-shown');

    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      if (result.status) {
        els.status.classList.add('is-' + result.status.key);
        els.statusVal.textContent  = result.status.label;
        els.statusNote.textContent = result.status.note || '';
      } else {
        els.statusVal.textContent  = '';
        els.statusNote.textContent = '';
      }
    }

    renderFigures(result.figures);
    renderRows(result.rows);

    if (els.warnings) {
      if (result.warnings && result.warnings.length) {
        els.warnings.textContent = result.warnings[0];
        els.warnings.style.display = '';
      } else {
        els.warnings.style.display = 'none';
      }
    }

    writePermalink(input);
  }

  /* ====================================================================
     Shareable result permalinks
     ==================================================================== */
  function writePermalink(input) {
    if (!window.history || !window.history.replaceState) return;
    var q = FIELDS.map(function (f) {
      var v = input[f.name];
      if (f.type === 'checkbox') return v ? f.key + '=1' : '';
      if (v == null || v !== v || v === '') return '';
      return f.key + '=' + encodeURIComponent(v);
    }).filter(Boolean).join('&');
    try {
      window.history.replaceState(null, '', window.location.pathname + (q ? '?' + q : ''));
    } catch (e) {}
  }

  function applyPermalink() {
    if (!window.URLSearchParams) return;
    var p = new URLSearchParams(window.location.search);
    var any = false;
    FIELDS.forEach(function (f) {
      if (!p.has(f.key)) return;
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') el.checked = p.get(f.key) === '1';
      else el.value = p.get(f.key);
      any = true;
    });
    return any;
  }

  /* ====================================================================
     Init
     ==================================================================== */
  ['input', 'change'].forEach(function (evt) {
    root.addEventListener(evt, function (e) {
      if (e.target.closest('[data-r-form]')) render();
    });
  });

  applyPermalink();
  render();

  /* Exposed for testing and debugging only. */
  window.PC_WGC = { compute: compute };
})();
